import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const MobileAppBenefitIllustration: FunctionComponent<Props> = ({ size = 72 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { benefitIllustration } = colors.icons
  return (
    <Svg width={size} height={size} viewBox='0 0 72 72' fill='none'>
      <Path
        d='M30.4817 18.4834C30.4817 18.4834 40.6946 15.7976 41.6966 15.9578C42.6214 16.1054 43.2928 16.4209 44.2309 19.045C45.1337 21.5715 51.8882 46.9875 51.9006 47.0465C52.6732 50.5255 51.3691 50.8296 50.1546 51.4024C48.9531 51.9679 35.3408 55.5531 31.7163 56.4965C30.7671 56.7435 29.71 56.7555 28.8688 56.4029C28.2023 56.1235 27.496 55.8899 26.554 53.0373C25.3557 49.4114 19.4093 25.2903 19.4093 25.2903C19.4093 25.2903 18.745 22.3219 21.1602 21.482C23.5765 20.6418 30.4817 18.4834 30.4817 18.4834Z'
        fill={benefitIllustration.secondary.fill}
      />
      <Path
        d='M30.9722 20.2107C30.9722 20.2107 39.8213 17.8752 40.6802 17.9823C41.4732 18.0811 42.0456 18.3176 42.8001 20.3794C43.5263 22.3653 48.8319 42.385 48.8423 42.4321C49.4377 45.1761 48.3094 45.4434 47.2511 45.9211C46.2052 46.3941 34.411 49.511 31.2708 50.332C30.4476 50.547 29.5377 50.5774 28.82 50.3158C28.2517 50.1081 27.6483 49.9362 26.8942 47.6935C25.9354 44.843 21.2999 25.8327 21.2999 25.8327C21.2999 25.8327 20.7872 23.4915 22.8849 22.7771C24.9822 22.0615 30.9725 20.2119 30.9725 20.2119L30.9722 20.2107Z'
        fill={benefitIllustration.primary.fill}
      />
      <Path
        d='M39.8095 52.9964C40.5999 52.7803 41.0656 51.9643 40.8495 51.1739C40.6334 50.3834 39.8174 49.9178 39.027 50.1339C38.2365 50.35 37.7709 51.1659 37.987 51.9564C38.203 52.7469 39.019 53.2125 39.8095 52.9964Z'
        fill={benefitIllustration.primary.fill}
      />
      <Path
        d='M39.402 39.0676C39.753 38.9852 40.741 38.7016 40.741 38.7016L41.3593 40.9636C41.3593 40.9636 40.4581 41.2099 40.0203 41.3296C38.7071 41.6886 35.1914 42.3931 34.2192 38.8368C33.1096 34.7778 30.9512 26.8821 30.9512 26.8821L33.2686 26.2486C33.2686 26.2486 35.8462 35.6774 36.3615 37.5624C36.8424 39.3217 38.1394 39.3588 39.402 39.0676Z'
        fill={benefitIllustration.secondary.fill}
      />
    </Svg>
  )
}
